import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FreshnessStamp } from '../FreshnessStamp/FreshnessStamp.js';
export function PageHeader(props) {
    const { title, subtitle, freshness, right, className, variant = 'display', headingId } = props;
    const app = variant === 'app';
    return (_jsxs("header", { className: className, "data-page-header": variant, style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: app ? 'var(--space-2) var(--space-4)' : 'var(--space-4)',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginBottom: app ? 0 : 'var(--space-6)',
            minWidth: 0,
        }, children: [_jsxs("div", { style: { display: 'grid', gap: app ? 'var(--space-1)' : 'var(--space-2)', minWidth: 0 }, children: [_jsx("h1", { id: headingId, tabIndex: headingId ? -1 : undefined, style: app ? {
                            margin: 0,
                            fontFamily: 'var(--font-ui)',
                            fontSize: 'var(--fs-xl)',
                            fontWeight: 600,
                            color: 'var(--text)',
                            overflowWrap: 'anywhere',
                        } : {
                            margin: 0,
                            fontFamily: 'var(--font-display)',
                            fontStyle: 'italic',
                            fontSize: 'var(--font-size-2xl)',
                            color: 'var(--text)',
                        }, children: title }), subtitle ? (_jsx("p", { style: {
                            margin: 0,
                            color: 'var(--text-muted)',
                            fontSize: app ? 'var(--fs-sm)' : 'var(--font-size-2xs)',
                            fontFamily: 'var(--font-ui)',
                        }, children: subtitle })) : null, freshness ? _jsx(FreshnessStamp, { ...freshness }) : null] }), right ? _jsx("div", { style: { display: 'flex', flexWrap: 'wrap', gap: 'var(--space-2)' }, children: right }) : null] }));
}
//# sourceMappingURL=PageHeader.js.map